export const servicesData = {
  title: "Our Services",
  subtitle:
    "Our carefully assembled self-managed experts continuously support Scandinavian companies with technical expertise. Explore our range of services and pick up the one which suits you best.",
  title2: "What Do We Serve ?",
  technology:
    "Comprehensive technology services that integrate digital craftsmanship and business goals.",
  digital_marketing:
    "We help you translate a simple idea into an exotic Digital design transformation vision.",
  contect_marketing:
    "End-to-end neuromarketing services and branding strategies of the digital world.",
};
